import { gql } from '@apollo/client';

// Organization queries
export const GET_ORGANIZATIONS_QUERY = gql`
  query GetOrganizations($limit: Int = 100, $offset: Int = 0) {
    organizations(limit: $limit, offset: $offset) {
      edges {
        id
        name
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

export const GET_ORGANIZATION_QUERY = gql`
  query GetOrganization($id: UUID!) {
    organization(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
